import { SHOW_GDPR, HIDE_GDPR } from "../action_types";
import store from "../store";

const showGdpr = () => ({
    type: SHOW_GDPR,
});

const hideGdpr = () => ({
    type: HIDE_GDPR,
});

export const boundShowGdpr = () => store.dispatch(showGdpr());
export const boundHideGdpr = () => store.dispatch(hideGdpr());
